import React from 'react'
import Tophead from './Header/Tophead'
import Footer from './Footer/Footer'

const Weblayout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Tophead />
      <main className="flex-grow bg-white pt-[130px] lg:pt-[180px]">
        {children}
      </main>
      <Footer />
    </div>
  )
}

export default Weblayout